import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../components/Common/DataTable/DataTable";
import { eventMyDrafts } from "../../../utils/mainTabs/events/eventMyDrafts";
import { useFetchData } from "../../../hooks/useFetchData";
import {
  eventGetMyDraftsActionHandler,
  deleteEventShotclassActionHandler,
} from "../../../store/actions/actionHandlers/eventActionHandler";
import Modal from "../../../components/Common/Modal/Modal";
import classes from "./EventMyDraft.module.scss";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import { FormattedMessage } from "react-intl";

const EventMyDraft = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pageSize = 8;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    handleCurrentPage,
    handleSearchQuery,
    loading,
  } = useFetchData(eventGetMyDraftsActionHandler, pageSize);
  const { tenantName, refreshAPIS, setRefreshAPIS } = useOutletContext();
  const { searchPlaceHolder, columns } = eventMyDrafts;
  const [shotclassId, setShotclassId] = useState(0);
  const [tableColumns, setTableColumns] = useState([]);

  const handleDeleteModal = useCallback((shotclassId) => {
    setShotclassId(shotclassId);
  }, []);
  useEffect(() => {
    if (refreshAPIS) {
      handleSearchQuery("");
      setRefreshAPIS(false);
    }
  }, [refreshAPIS]);
  const handleDeleteShotclass = () => {
    dispatch(
      deleteEventShotclassActionHandler(
        shotclassId
        // data,
        // updatedData,
        // setData,
        // setUpdatedData,
        // handleSearchQuery
      )
    ).then((isDeleted) => {
      if (isDeleted) {
        dispatch(setErrorHandler(errorTypes.SUCCESS, "Event has been deleted"));
        const filteredData = data.filter((row) => row.ID !== shotclassId);
        const filteredUpdatedData = updatedData.filter(
          (row) => row.ID !== shotclassId
        );
        setData(filteredData);
        setUpdatedData(filteredUpdatedData);
      }
    });
    handleDeleteModal(0);
  };

  useEffect(() => {
    let newTableColumns = columns(navigate, handleDeleteModal, tenantName);
    setTableColumns(newTableColumns);
  }, [columns, navigate, handleDeleteModal, tenantName]);

  return (
    <>
      {/* <div>hello event my draft page</div> */}
      <DataTable
        columns={tableColumns}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={totalRows}
        uniqueFieldName={"ID"}
        fetchMoreData={handleCurrentPage}
        searchable
        setSearchQuery={handleSearchQuery}
        placeholder={searchPlaceHolder}
        loading={loading}
      />
      <Modal
        handleSubmit={handleDeleteShotclass}
        isOpen={shotclassId}
        heading={"Event Message"}
        toggle={() => handleDeleteModal(0)}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGROUP_CANCELBTN" />}
        width={"46.2"}
        height={"26.9"}
      >
        <div className={classes.eventMyDrafts__deleteModal}>
          <div className={classes.eventMyDrafts__deleteModal__text}>
            Are you sure you want to delete this event?
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EventMyDraft;
